import {reqCategoryList,reqSildeList,reqFloorList} from '@/api'

// actions中的方法用于响应组件中的动作 —— 服务员
const actions = {
  // 用于获取三级分类信息
  async getCategoryList({commit}){
    // 发请求获取三级分类数据
    const {code,message,data} = await reqCategoryList()
    // 判断业务逻辑是否成功
    if(code === 200){
      // 联系厨师
      commit('SAVE_CATEGORY_List',data)
    }else{
      // 提示一下业务逻辑失败的原因
      alert(`获取导航数据失败：${message}`)
    }
  },
  // 用于获取轮播图数据
  async getSildeList({commit}){
    // 发请求获取数据
    const {code,data,message} = await reqSildeList()
    // 判断业务逻辑是否成功
    code === 200 ? commit('SAVE_SLIDE_LIST',data) : alert(`获取轮播图数据失败：${message}`)
  },
  // 用于获取楼层数据
  async getFloorList({commit}){
    // 发请求获取楼层数据
    const {code,data,message} = await reqFloorList()
    // 判断业务逻辑
    code === 200 ? commit('SAVE_FLOOR_LIST',data) : alert(`获取楼层数据失败：${message}`)
  }
}

// mutations中的方法用于修改状态 —— 厨师
const mutations = {
  // 用于存储三级分类数据
  SAVE_CATEGORY_List(state,list){
    state.categoryList = list
  },
  // 用于存储轮播图数据
  SAVE_SLIDE_LIST(state,list){
    state.slideList = list
  },
  // 用于存储楼层数据
  SAVE_FLOOR_LIST(state,list){
    state.floorList = list
  }
}

// state用于指定初始的数据 —— 原材料
const state = {
  categoryList:[], //三级分类数据
  slideList:[], //三级分类数据
  floorList:[]
}

export default {
  namespaced:true,
  actions,
  mutations,
  state
}